import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeleteModalComponent } from '@components/delete-modal/delete-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { sortTable } from 'src/app/helpers/sort-table';
import { Center } from 'src/app/_models/center.model';
import { HomeVisitFee } from 'src/app/_models/homeVisitFees.model';
import { CentersService } from 'src/app/_services/centers.service';
import { environment, baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-home-visit-fees-list',
  templateUrl: './home-visit-fees-list.component.html',
  styleUrls: ['./home-visit-fees-list.component.scss'],
})
export class HomeVisitFeesListComponent implements OnInit {
  pageTitle;
  fees: HomeVisitFee[] = [];
  filteredFees: HomeVisitFee[] = [];
  center: Center;
  invertSort: boolean = false;
  theadArray = [
    'Fee Area EN Name',
    'Fee Area AR Name',
    'Fee Value',
    'Fee Actions',
  ];
  modalRef: BsModalRef;

  constructor(
    private centerService: CentersService,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    const centerId = this.activatedRoute.snapshot.params.centerId;
    this.getCenterById(centerId);
    this.getAllFeesInCenter(centerId);
  }

  getAllFeesInCenter(id) {
    this.centerService.getAllFeesInCenter(id).subscribe((res) => {
      this.fees = res?.data;
      this.filteredFees = this.fees;
    });
  }

  getCenterById(id) {
    this.centerService.getCenterById(id).subscribe((res) => {
      this.center = res?.data;
      this.pageTitle = `Fees in ${this.center?.name}`
    });
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredFees = sortTable(
      this.filteredFees,
      'homeVisitFees',
      this.invertSort
    );
  }

  onDeleteFee(event, item): void {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered modal-danger',
      initialState: {
        itemId: item.id,
        itemName: item.areaName,
      },
    };

    this.modalRef = this.modalService.show(DeleteModalComponent, initialState);

    this.modalRef.content.event.subscribe((data) => {
      this.onDeleteFeeSubmit(data);
    });
  }

  onDeleteFeeSubmit(feeId) {
    this.centerService.deleteFee(feeId).subscribe((res) => {
      showNotification('success', `Fee has been deleted`, this.toastr);

      this.fees = this.fees.filter((fee) => fee.id !== feeId);

      this.filteredFees = [...this.fees];

      this.modalRef.hide();
    });
  }
}
